import { Backdrop, Box, CircularProgress, styled } from '@mui/material';
import { useAppStore } from '../store/app';
import useCheckoutStore, { checkoutActions } from '../store/checkout';
import EmailGif from '@src/images/email.gif';
import FileGif from '@src/images/file.gif';
import CartGif from '@src/images/shopping-cart.gif';
import CashRegisterGif from '@src/images/cash-register.gif';

const CustomBackdrop = styled(Backdrop, {
  name: 'Spinner',
  slot: 'root',
})``;

const checkoutIcons = {
  [checkoutActions.CHECKOUT_ACTION_BUY_NOW]: CashRegisterGif,
  [checkoutActions.CHECKOUT_ACTION_ADD_TO_CART]: CartGif,
  [checkoutActions.CHECKOUT_ACTION_CREATE_QUOTE]: EmailGif,
  [checkoutActions.CHECKOUT_ACTION_CREATE_ORDER]: FileGif,
  [checkoutActions.CHECKOUT_ACTION_CREATE_INFO]: FileGif,
  style: {
    borderRadius: '640px',
    width: '64px',
    padding: '14px',
    background: '#fff',
    '> img': {
      width: '100%',
      height: 'auto',
      display: 'block'
    }
  }
};

function Spinner({ root, ...rest }) {
  const app = useAppStore();
  const checkout = useCheckoutStore();
  const open = app.isBlocked() || checkout.processing;
  const icon = (checkout.action && checkoutIcons[checkout.action]) ?? checkoutIcons[checkout.action];

  return (
    <CustomBackdrop open={open} {...rest}>
      <span>
        {(!checkout.action || !icon) && <CircularProgress color="inherit" />}
        {icon && (
          <Box sx={checkoutIcons.style}>
            <Box component={'img'} src={icon} />
          </Box>
        )}
      </span>
    </CustomBackdrop>
  );
};

export default Spinner;
